import { render, staticRenderFns } from "./ModalX1.vue?vue&type=template&id=76ff52aa&"
import script from "./ModalX1.vue?vue&type=script&lang=js&"
export * from "./ModalX1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports